// Copyright © 2021 Move Closer
import { TILE_L_AREA, TILE_S_AREA, TILE_XL_AREA } from './Tile.config';
import { TileVersion } from './Tile.contracts';
/**
 * Calculates the area.
 *
 * @param x - X-axis
 * @param y - Y-axis.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const calculateArea = (x, y) => {
    if (typeof x !== 'number') {
        throw new Error(`calculateArea(): Expected [x] to be a type of [number], but instead got [${typeof x}]!`);
    }
    if (typeof y !== 'number') {
        throw new Error(`calculateArea(): Expected [y] to be a type of [number], but instead got [${typeof y}]!`);
    }
    return x * y;
};
/**
 * Counts the articles for the passed-in module and tile size configuration.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getArticlesCount = (moduleSize, moduleVersion) => {
    const { colSpan, rowSpan } = moduleSize;
    const moduleArea = colSpan * rowSpan;
    switch (moduleVersion) {
        case TileVersion.S: {
            return Math.floor(moduleArea / TILE_S_AREA);
        }
        case TileVersion.L: {
            return Math.floor(moduleArea / TILE_L_AREA);
        }
        case TileVersion.XL: {
            return Math.floor(moduleArea / TILE_XL_AREA);
        }
        case TileVersion.FiveColumns: {
            return 5;
        }
        case TileVersion.FourColumns: {
            return 4;
        }
        default: {
            return 3;
        }
    }
};
//
// /**
//  * Calculates the area that the Tile of a given size requires to render properly.
//  *
//  * @param tileSize - The size of the tile.
//  * @param [breakpoint=Breakpoint.LG] - The breakpoint of interest.
//  *  You probably **DON'T** want to change its default value.
//  *
//  * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
//  */
// const calculateSingleTileArea = (tileSize: TileSize, breakpoint: TileBreakpoint = Breakpoint.LG): number => {
//   if (typeof tileSizeSpaceRegistry[tileSize] === 'undefined') {
//     throw new Error(`calculateSingleTileArea(): There's no data for the Tile with size [${tileSize}] in the [tileSizeSpaceRegistry]!\nFull config object: ${JSON.stringify(tileSizeSpaceRegistry)}`)
//   }
//
//   if (typeof tileSizeSpaceRegistry[tileSize][breakpoint] === 'undefined') {
//     throw new Error(`calculateSingleTileArea(): There's no data for the Tile with size [${tileSize}] and the breakpoint [${breakpoint}] in the [tileSizeSpaceRegistry]!\nFull config object: ${JSON.stringify(tileSizeSpaceRegistry)}`)
//   }
//
//   const { colSpan, rowSpan } = tileSizeSpaceRegistry[tileSize][breakpoint]
//
//   if (typeof colSpan !== 'number' || typeof rowSpan !== 'number') {
//     throw new Error(`calculateSingleTileArea(): Failed to resolve value for the [colSpan] or [rowSpan]!\nFull config object: ${JSON.stringify(tileSizeSpaceRegistry)}`)
//   }
//
//   return calculateArea(colSpan, rowSpan)
// }
//
// /**
//  * Counts how many tiles of a given size can fit in the given available space.
//  *
//  * @param tileVersion - Module's version.
//  * @param availableSpace - Space available in the grid.
//  *
//  * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
//  */
// const countTilesForAvailableSpace = (tileVersion: TileVersion, availableSpace: Space): number => {
//   if (tileVersion === TileVersion.FourColumns) {
//     return 4 * availableSpace.rowSpan / 2
//   } else if (tileVersion === TileVersion.FiveColumns) {
//     return 5 * availableSpace.rowSpan / 2
//   } else {
//     const availableArea: number = calculateArea(availableSpace.colSpan, availableSpace.rowSpan)
//     const singleTileArea: number = calculateSingleTileArea(tileVersion as unknown as TileSize)
//     return availableArea / singleTileArea
//   }
// }
